import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-titulo-principal',
  templateUrl: './titulo-principal.component.html',
  styleUrls: ['./titulo-principal.component.scss']
})
export class TituloPrincipalComponent implements OnInit {

  @Input() titulo!: string;
  @Input() fontSizeTitle: string = 'fs-4';
  @Input() subTitulo!: string;
  @Input() fontSizeSubTitle: string = 'fs-4';
  @Input() icone: any;
  @Input() classIcone: string = 'fs-4';

  constructor() { }

  ngOnInit() {
  }

}
